import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';

import { PureRender } from 'utils/component-helpers';
import 'antd/lib/modal/style/index.less';
import DeedAttendeeAddList from 'retired/DeedAttendeeAddList';
import { selectUser } from 'entities/user/selectors';
import { Features } from 'utils/features';

import { selectTerm, selectResults, selectSearchLoading } from './selectors';
import * as Actions from './actions';
import './styles.less';

const AddAttendeesOverlay = ({
  visible,
  enableSearch,
  searchLoading,
  results,
  term,
  deed,
  actions,
  close,
}) => {
  const addAttendees = (deedId, attendeesWithId, attendeesWithEmail, roles) => {
    actions.addAttendeesAction(deedId, attendeesWithId, attendeesWithEmail, roles);
  };

  const user = useSelector(selectUser);

  return (
    <DeedAttendeeAddList
      visible={visible}
      enableSearch={enableSearch}
      searchLoading={searchLoading}
      results={results}
      term={term}
      actions={actions}
      deed={deed}
      onAdd={addAttendees}
      titleText="Add Attendees"
      buttonAddText="Add Attendees"
      close={close}
      allowMultipleRoles={deed.type === 'Event' && user?.hasFeature(Features.MULTIPLE_SHIFTS)}
    />
  );
};

AddAttendeesOverlay.propTypes = {
  visible: PropTypes.bool,
  term: PropTypes.string,
  results: PropTypes.object,
  enableSearch: PropTypes.bool,
  searchLoading: PropTypes.bool,
  deed: PropTypes.object,
  actions: PropTypes.object,
  close: PropTypes.func,
};

export default connect(
  (state) => ({
    results: selectResults(state),
    searchLoading: selectSearchLoading(state),
    term: selectTerm(state),
  }),
  (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch),
  })
)(PureRender(AddAttendeesOverlay));
